export default __webpack_public_path__ + "images/79fcad59ae5af0dd0c06f9cd37542e48-App-Name.jpg";